import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// Actions
import {
    fetchAssistantEvents,
    fetchHistoricalEvents,
    learnDevice,
    onAddNewDevice,
    onClearSelection,
    onToggleSelectItem,
    onZoomSelection,
} from '../../data/training/actions';
import { fetchAllMeters } from '../../data/meters/actions';
import {
    onSetSmartTrainingDeviceFilter,
    onSetSmartTrainingMinWh,
    onSetSmartTrainingPeriod,
    setLastPreselectedGroupBy,
    setLastPreselectedMeter,
} from '../../data/app/actions';
import { onAddOrEditDeviceModalIsLoading } from '../../data/homes/actions';
import { fetchAllDevices } from '../../data/devices/actions';
import { fetchAllDeviceTypes } from '../../data/deviceTypes/actions';

// Selectors
import { getMetersListSorted } from '../../data/meters/selectors';
import { getUserId, isRoleAdministrator } from '../../data/auth/selectors';
import {
    getPreselectedGroupById,
    getPreselectedMeterId,
    getSmartTrainingFilteredDevice,
    getSmartTrainingMinWh,
    getSmartTrainingPeriodFrom,
    getSmartTrainingPeriodTo,
    selectedLangageSelector,
} from '../../data/app/selector';
import {
    getAssistantList,
    getHistoricalListSeparated,
    getSelectedList,
    isZoomEnabled,
} from '../../data/training/selectors';
import { getDeviceList } from '../../data/devices/selectors';
import { getDeviceTypesList } from '../../data/deviceTypes/selectors';
import { getAddOrEditDeviceModalIsLoading } from '../../data/homes/selectors';

// Others
import { Breadcrumb, Button, Card, Icon, Layout, Row, Select, Slider, Tabs, Tooltip } from 'antd';
import { strings } from '../../localization';
import { convertToLocalDate, generateDateTimeString, ROUTE_NAMES } from '../../utils';
import { Bubble } from 'react-chartjs-2';
import { smartTrainingPeriod } from '../../constants/index';
import MeterSelectBox from '../common/MeterSelectBox';
import SaveEvent from '../training/SaveEvent';
import ChangeEvent from '../training/ChangeEvent';
import TrainingPeriodSelectModal from './TrainingPeriodSelectModal';
import DeviceAssistant from './DeviceAssistant';

const { TabPane } = Tabs;

class SmartTraining extends React.Component {

    options = {
        maintainAspectRatio: false,
        aspectRatio: 2,
        legend: {
            display: true,
            position: 'right'
        },
        onClick: (a, b) => {
            if (b && b.length > 0)
                this.handleSaveEvent(b[0]);
        },
        elements: {
            point: {
                pointStyle: context => context.dataset.pointStyle,
                backgroundColor: context => {
                    const rec = context.dataset.data[context.dataIndex];
                    return rec && rec.selected ?
                        context.dataset.borderColor :
                        (rec && rec.device >= 0 ? context.dataset.hoverColor : context.dataset.bgColor);
                },
                borderWidth: 1,
                hoverBackgroundColor: context => {
                    const rec = context.dataset.data[context.dataIndex];
                    return rec && rec.selected ?
                        context.dataset.borderColor :
                        (rec && rec.device < 0 ? context.dataset.hoverColor : context.dataset.bgColor);
                },
                borderColor: context => context.dataset.borderColor,
                hoverBorderWidth: 3,
                radius: context => {
                    const rec = context.dataset.data[context.dataIndex];
                    return rec && rec.device < 0 ? 20 : 10;
                }
            }
        },
        tooltips: {
            displayColors: true,
            callbacks: {
                // label: (tooltipItem, data) => data.datasets[tooltipItem.datasetIndex].label,
                afterLabel: (tooltipItem, data) => `${Math.round(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].x * 100) / 100} ${strings.training.wattUnit}  ${Math.round(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y * 100) / 100} ${strings.training.var}`,
                label: (tooltipItem, data) => {
                    // const device = data.datasets[tooltipItem[0].datasetIndex].data[tooltipItem[0].index].id;
                    const device = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].id;
                    return this.getDevName(device);
                },
                beforeFooter: (tooltipItem, data) => {
                    const { ts } = data.datasets[tooltipItem[0].datasetIndex].data[tooltipItem[0].index];
                    const { lang } = this.props;
                    return generateDateTimeString(new Date(ts), true, lang);
                },
                footer: (tooltipItem, data) => {
                    const { ts, duration } = data.datasets[tooltipItem[0].datasetIndex].data[tooltipItem[0].index];
                    const { lang } = this.props;
                    return generateDateTimeString(new Date(ts + duration), true, lang);
                },
                afterFooter: (tooltipItem, data) => {
                    const device = data.datasets[tooltipItem[0].datasetIndex].data[tooltipItem[0].index].id;
                    return device < 0 ? 'Click to save' : null;
                }
            }
        },
        scales: {
            xAxes: [{
                scaleLabel: {
                    display: true,
                    labelString: 'ACTIVE POWER',
                    fontColor: '#555',
                    fontStyle: 'bold'
                },
                ticks: {
                    callback: value => `${Math.round(value)} ${strings.training.wUnit}`
                }
            }],
            yAxes: [{
                scaleLabel: {
                    display: true,
                    labelString: 'REACTIVE POWER',
                    fontColor: '#555',
                    fontStyle: 'bold'
                },
                ticks: {
                    callback: value => `${Math.round(value)} ${strings.training.var}`
                }
            }]
        },
        layout: {
            padding: {
                left: 0,
                right: 0,
                top: 50,
                bottom: 0
            }
        },
        pan: {
            enabled: true,
            mode: 'xy'
        },
        zoom: {
            enabled: true,
            mode: 'xy',
            speed: 0.04
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            selectedMeter: null,
            showSaveModal: false,
            showChangeModal: false,
            showDeviceAssistant: false,
            deviceToChangeId: -1,
            clickedEvent: null,
            showPeriodSelect: false,
        };
        this.date = new Date();
        this.chart = React.createRef();
    }

    componentWillMount() {
        const { fetchAllMeters, metersData, fetchAllDeviceTypes, deviceTypesList } = this.props;
        if (!deviceTypesList)
            fetchAllDeviceTypes();
        if (!metersData) {
            fetchAllMeters();
        } else {
            this.selectMeter(this.props);
        }
    }

    componentWillReceiveProps(nextProps) {
        this.selectMeter(nextProps);
    }

    refreshHistoricalEvents = (meterId) => {
        this.date = new Date();
        const { fetchHistoricalEvents, periodFrom, periodTo, minWh } = this.props;
        let { selectedMeter } = this.state;
        if (meterId !== null) selectedMeter = meterId;
        const unix = this.date.getTime();
        const from = unix - (smartTrainingPeriod.periodLength - periodFrom) * 3600000;
        const to = unix - (smartTrainingPeriod.periodLength - periodTo) * 3600000;
        fetchHistoricalEvents(selectedMeter, from, to, minWh);
    };

    changedMinWh = (minWh) => {
        this.date = new Date();
        const { fetchHistoricalEvents, periodFrom, periodTo } = this.props;
        const { selectedMeter } = this.state;
        const unix = this.date.getTime();
        const from = unix - (smartTrainingPeriod.periodLength - periodFrom) * 3600000;
        const to = unix - (smartTrainingPeriod.periodLength - periodTo) * 3600000;
        fetchHistoricalEvents(selectedMeter, from, to, minWh);
    };

    handleSaveEvent = event => {
        const { data, onToggleSelectItem, groupBy } = this.props;
        const record = data.datasets[event._datasetIndex].data[event._index];

        if (record.id < 0) {
            // Unknown
            if (groupBy > 1) {
                // cluster mode
                for (const item of data.datasets[event._datasetIndex].data) {
                    if (item.phase === record.phase && item.id < 0)
                        onToggleSelectItem(item);
                }
            } else onToggleSelectItem(record);

            /*
            console.log(record);
            this.setState({
                showSaveModal: true,
                selectedEvent: record
            });
            */
        } else {
            // change it
            this.changeSelectedEvent(record);
        }
        // console.log(record);
    };

    saveSelectedEvents = () => {
        const { selectedItems } = this.props;
        if (selectedItems.length === 0) return;
        this.setState({
            showSaveModal: true
        });
    };

    changeSelectedEvent = rec => {
        console.log(rec.device);
        this.setState({
            deviceToChangeId: rec.device,
            clickedEvent: rec,
            showChangeModal: true
        });
    };

    selectMeter = (props) => {
        const { selectedMeter } = this.state;
        const { userId, metersData, preselectedMeterId, fetchAllDevices } = props;
        if (
            (selectedMeter === null) &&
            metersData &&
            metersData.size > 0 &&
            userId !== undefined
        ) {
            let meterId = metersData.get(0).get('id');
            if (preselectedMeterId >= 0) {
                meterId = preselectedMeterId;
            } else {
                const { setLastPreselectedMeter } = this.props;
                setLastPreselectedMeter(meterId);
            }
            fetchAllDevices(meterId, true);
            this.refreshHistoricalEvents(meterId);
            this.setState(() => ({
                selectedMeter: meterId
            }));
        }
    };

    handleMeterChange = id => {
        const { setLastPreselectedMeter, fetchAllDevices } = this.props;
        setLastPreselectedMeter(id);
        fetchAllDevices(id, true);
        this.setState(() => ({
            selectedMeter: id
        }));
        this.refreshHistoricalEvents(id);
    };

    getDevName = dev => {
        const { deviceList } = this.props;
        if (dev < 0 || !deviceList) return strings.training.unknownDevice;
        const devices = deviceList.filter(item => item.id === dev);
        return devices.length > 0 ? `${devices[0].name}${devices[0].deleted ? ` [${strings.training.deleted}]` : ''}` : strings.training.unknownDevice;
    };

    hideSaveModal = () => {
        const { onAddOrEditDeviceModalIsLoading } = this.props;
        onAddOrEditDeviceModalIsLoading(false);
        this.setState({
            showSaveModal: false
        });
    };

    hideChangeModal = () => {
        const { onAddOrEditDeviceModalIsLoading } = this.props;
        onAddOrEditDeviceModalIsLoading(false);
        this.setState({
            showChangeModal: false
        });
    };

    deviceAssistant = () => {
        const { fetchAssistantEvents, periodFrom, periodTo, minWh, lang } = this.props;
        const { selectedMeter } = this.state;
        const unix = this.date.getTime();
        const from = unix - (smartTrainingPeriod.periodLength - periodFrom) * 3600000;
        const to = unix - (smartTrainingPeriod.periodLength - periodTo) * 3600000;
        fetchAssistantEvents(selectedMeter, from, to, minWh, lang);
        this.setState({
            showDeviceAssistant: true,
        });
    };

    hideDeviceAssistant = () => {
        this.setState({
            showDeviceAssistant: false
        });
    };

    saveDeviceAssistant = () => {
        const { selectedMeter } = this.state;
        const { fetchAllDevices } = this.props;
        fetchAllDevices(selectedMeter, true);
        this.refreshHistoricalEvents(selectedMeter);
        this.setState({
            showDeviceAssistant: false
        });
    };

    eventSaver = (meterId, devId, idx) => {
        const { selectedItems, learnDevice, onClearSelection } = this.props;
        if (selectedItems && idx < selectedItems.length) {
            // save another
            learnDevice(meterId, devId, selectedItems[idx]).then(() => {
                this.eventSaver(meterId, devId, idx + 1);
            });
        } else {
            // finished
            // this.clearSelection();
            onClearSelection();
            this.refreshHistoricalEvents(null);
            this.hideSaveModal();
        }
    };

    saveEvent = values => {
        const { selectedMeter } = this.state;
        if (values.device < 0) {
            // add new
            const { onAddNewDevice, metersData, fetchAllDevices } = this.props;
            const meters = metersData && metersData.toJS();
            if (!meters) return;
            const meter = meters.filter(item => item.id === selectedMeter);
            if (!meter || meter.length < 1) return;
            // /*
            onAddNewDevice(selectedMeter, {
                name: values.name,
                count: values.count,
                type: values.type,
            }, meter[0].homeIdentifier).then(res => {
                const devId = res.body.id;
                // console.log(devId);
                fetchAllDevices(selectedMeter);
                this.eventSaver(selectedMeter, devId, 0);
            });
            // */
            // console.log(values, meter[0].homeIdentifier);
        } else {
            const { onAddOrEditDeviceModalIsLoading } = this.props;
            onAddOrEditDeviceModalIsLoading(true);
            // console.log(values.device);
            this.eventSaver(selectedMeter, values.device, 0);
        }
    };

    changeEvent = values => {
        const { selectedMeter, clickedEvent, deviceToChangeId } = this.state;
        const { onAddOrEditDeviceModalIsLoading, metersData, learnDevice } = this.props;
        onAddOrEditDeviceModalIsLoading(true);
        const meters = metersData && metersData.toJS();
        if (!meters) return;
        const meter = meters.filter(item => item.id === selectedMeter);
        if (!meter || meter.length < 1) return;

        learnDevice(selectedMeter, values.device, clickedEvent, deviceToChangeId !== 0, true).then(() => {
            this.refreshHistoricalEvents(null);
            this.hideChangeModal();
        });
    };

    zoomOnSelection = () => {
        const { selectedItems, onZoomSelection, zoomIsEnabled } = this.props;
        this.resetZoom();
        if (zoomIsEnabled) {
            onZoomSelection(false, 0, 0, 0, 0);
            return;
        }
        if (selectedItems.length < 2) return;
        let xmin = 0;
        let ymin = 0;
        let xmax = 0;
        let ymax = 0;
        for (let i = 0; i < selectedItems.length; i += 1) {
            if (i === 0) {
                xmin = selectedItems[i].x;
                xmax = selectedItems[i].x;
                ymin = selectedItems[i].y;
                ymax = selectedItems[i].y;
            } else {
                if (selectedItems[i].x > xmax) xmax = selectedItems[i].x;
                if (selectedItems[i].x < xmin) xmin = selectedItems[i].x;
                if (selectedItems[i].y > ymax) ymax = selectedItems[i].y;
                if (selectedItems[i].y < ymin) ymin = selectedItems[i].y;
            }
        }
        onZoomSelection(true, xmin, xmax, ymin, ymax);
        // console.log(xmin, xmax, ymin, ymax);
    };

    handleGroupByChange = val => {
        const { setLastPreselectedGroupBy } = this.props;
        setLastPreselectedGroupBy(val);
        //

    };

    clearSelection = () => {
        const { onClearSelection, onZoomSelection, zoomIsEnabled } = this.props;
        if (zoomIsEnabled) {
            onZoomSelection(false, 0, 0, 0, 0);
        }
        onClearSelection();
        this.resetZoom();
    };

    resetZoom = () => {
        const { onZoomSelection } = this.props;
        onZoomSelection(false, 0, 0, 0, 0);
    };

    showPeriodSelectModal = () => {
        this.setState({
            showPeriodSelect: true,
        });
    };

    hidePeriodSelectModal = () => {
        this.setState({
            showPeriodSelect: false
        });
    };

    render() {
        const {
            selectedMeter,
            showSaveModal,
            showChangeModal,
            showDeviceAssistant,
            deviceToChangeId,
            showPeriodSelect,
        } = this.state;
        const {
            metersData,
            isAdmin,
            data,
            savingInProgress,
            selectedItems,
            zoomIsEnabled,
            lang,
            periodFrom,
            periodTo,
            minWh,
            deviceList,
            filteredDevice,
            groupBy,
        } = this.props;

        const unix = this.date.getTime();
        const fromTxt = generateDateTimeString(new Date(unix - (smartTrainingPeriod.periodLength - periodFrom) * 3600000), false, lang);
        const toTxt = generateDateTimeString(new Date(unix - (smartTrainingPeriod.periodLength - periodTo) * 3600000), false, lang);
        const marks = {
            0: {
                style: {
                    transform: 'translateX(0%)'
                },
                label: convertToLocalDate(new Date(unix - smartTrainingPeriod.periodLength * 3600000), lang)
            },
            144: convertToLocalDate(new Date(unix - (smartTrainingPeriod.periodLength - 144) * 3600000), lang),
            288: convertToLocalDate(new Date(unix - (smartTrainingPeriod.periodLength - 288) * 3600000), lang),
            432: convertToLocalDate(new Date(unix - (smartTrainingPeriod.periodLength - 432) * 3600000), lang),
            576: convertToLocalDate(new Date(unix - (smartTrainingPeriod.periodLength - 576) * 3600000), lang),
            720: {
                style: {
                    transform: 'translateX(-100%)'
                },
                label: convertToLocalDate(new Date(unix - (smartTrainingPeriod.periodLength - 720) * 3600000), lang)
            }
        };
        return (
            <Layout key='training-content'>
                <Layout.Content style={{ padding: '10px' }}>
                    <Card style={{ marginBottom: '30px' }}>
                        <h2 data-testid='headline'>{strings.training.route}</h2>
                        <Breadcrumb separator='>'>
                            <Breadcrumb.Item>{strings.appName}</Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <Link to={ROUTE_NAMES.TRAIN}>
                                    <Icon type='deployment-unit' />
                                    &nbsp;
                                    {strings.training.route}
                                </Link>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </Card>
                    <Card style={{ marginBottom: '30px' }}>
                        <span>
                          <MeterSelectBox
                              meterChange={this.handleMeterChange}
                              selectedMeter={selectedMeter}
                              metersData={metersData}
                              isAdmin={isAdmin}
                          />
                          <span>
                            <span style={{ marginRight: 10, marginLeft: 15 }}>{strings.training.filterDevice}</span>
                            <Select
                                onChange={val => {
                                    const { onSetSmartTrainingDeviceFilter } = this.props;
                                    onSetSmartTrainingDeviceFilter(val);
                                }}
                                value={filteredDevice}
                                dropdownMatchSelectWidth={false}
                                style={{
                                    minWidth: '130px',
                                    color: filteredDevice === -2 ? '#000' : '#E50'
                                }}
                            >
                                <Select.Option value={-2} key='key-2'>
                                    {strings.training.none}
                                </Select.Option>
                                <Select.Option value={-1} key='key-1'>
                                    {strings.training.unknownDevices}
                                </Select.Option>
                                {deviceList &&
                                    deviceList.filter(item => !item.deleted).map(item => (
                                        <Select.Option value={item.id} key={item.id}>
                                            {item.name}
                                        </Select.Option>
                                    ))}
                            </Select>
                        </span>
                        <Button
                            type='default'
                            style={{marginLeft: 15, fontWeight: 'bold'}}
                            icon='calendar'
                            onClick={this.showPeriodSelectModal}>
                            {fromTxt} -&gt; {toTxt}
                        </Button>
                        </span>
                        <br />
                        <TrainingPeriodSelectModal
                            isShown={showPeriodSelect}
                            hideModal={this.hidePeriodSelectModal}
                            periodLength={smartTrainingPeriod.periodLength}
                            callBack={this.refreshHistoricalEvents}
                        />
                        <div style={{ display: 'flex', marginTop: '8px' }}>
                            <div style={{ marginLeft: 'auto' }}>
                                <span style={{ marginRight: 10, marginLeft: 15 }}>min Wh:</span>
                                <Select
                                    onChange={val => {
                                        const { onSetSmartTrainingMinWh } = this.props;
                                        onSetSmartTrainingMinWh(val);
                                        this.changedMinWh(val);
                                    }}
                                    value={minWh}
                                    style={{
                                        minWidth: '70px'
                                    }}
                                >
                                    <Select.Option value={0}> {'0'} </Select.Option>
                                    <Select.Option value={1}> {'1'} </Select.Option>
                                    <Select.Option value={10}> {'10'} </Select.Option>
                                    <Select.Option value={100}> {'100'} </Select.Option>
                                    <Select.Option value={1000}> {'1000'} </Select.Option>
                                </Select>
                                <span>
                                <span style={{ marginRight: 10, marginLeft: 15 }}>{strings.training.groupBy}</span>
                                <Select
                                    onChange={val => this.handleGroupByChange(val)}
                                    value={groupBy}
                                    dropdownMatchSelectWidth={false}
                                    style={{
                                        minWidth: '130px'
                                    }}
                                >
                                    <Select.Option value={0} key='key-0'>
                                        {strings.training.groupByPhases}
                                    </Select.Option>
                                    <Select.Option value={1} key='key-1'>
                                        {strings.training.groupByDevices}
                                    </Select.Option>
                                    <Select.Option value={2} key='key-2'>
                                        {strings.training.groupBy5Clusters}
                                    </Select.Option>
                                    <Select.Option value={3} key='key-3'>
                                        {strings.training.groupBy10Clusters}
                                    </Select.Option>
                                    <Select.Option value={4} key='key-4'>
                                        {strings.training.groupBy20Clusters}
                                    </Select.Option>
                                </Select>
                            </span>
                                <Button
                                    disabled={selectedItems && selectedItems.length === 0}
                                    type='primary'
                                    style={{ marginLeft: 10 }}
                                    onClick={this.saveSelectedEvents}
                                >{strings.training.saveSelected}</Button>
                                <Button
                                    type='primary'
                                    style={{ marginLeft: 10 }}
                                    onClick={this.deviceAssistant}
                                >{strings.training.deviceAssistant}</Button>
                                <Tooltip placement='bottom' title={strings.training.zoomSelection}>
                                    <Button
                                        type={zoomIsEnabled ? 'primary' : 'default'}
                                        style={{ marginLeft: 10 }}
                                        shape='circle'
                                        icon='search'
                                        onClick={this.zoomOnSelection}
                                    />
                                </Tooltip>
                                <Tooltip placement='bottom' title={strings.training.clearSelection}>
                                    <Button
                                        type='default'
                                        style={{ marginLeft: 10 }}
                                        shape='circle'
                                        icon='undo'
                                        onClick={this.clearSelection}
                                    />
                                </Tooltip>
                                <Tooltip placement='bottom' title={strings.training.clearZoom}>
                                    <Button
                                        type='default'
                                        style={{ marginLeft: 10 }}
                                        shape='circle'
                                        icon='fullscreen-exit'
                                        onClick={() => this.resetZoom()}
                                    />
                                </Tooltip>
                            </div>
                        </div>
                        <br />
                        <Slider
                            range step={1}
                            reverse min={0}
                            max={smartTrainingPeriod.periodLength}
                            value={[periodFrom, periodTo]}
                            marks={marks}
                            tipFormatter={val => {
                                const unix = new Date().getTime();
                                return generateDateTimeString(new Date(unix - (smartTrainingPeriod.periodLength - val) * 3600000), false, lang);
                            }}
                            onChange={val => {
                                const { onSetSmartTrainingPeriod } = this.props;
                                let from = val[0];
                                let to = val[1];
                                if (to - from > smartTrainingPeriod.displayPeriod) {
                                    // > 3/7 days -> reduce period
                                    if (val[0] === periodFrom) {
                                        // [to] changed
                                        from = to - smartTrainingPeriod.displayPeriod;
                                    }
                                    if (val[1] === periodTo) {
                                        // [from] changed
                                        to = from + smartTrainingPeriod.displayPeriod;
                                    }
                                }
                                onSetSmartTrainingPeriod(from, to);
                            }}
                            onAfterChange={val => this.refreshHistoricalEvents(null)}
                        />
                    </Card>
                    <Row>
                        <Row>
                            <Tabs
                                defaultActiveKey='0'
                                size='large'
                                tabBarGutter={30}
                                tabBarStyle={{ marginBottom: 0 }}
                            >
                                <TabPane
                                    key='0'
                                    tab={
                                        <span>
                                        <Icon type='book' />
                                            {strings.training.route}
                                        </span>
                                    }
                                    style={{ maxHeight: 700 }}
                                >
                                    <Bubble ref={this.chart} data={data} options={this.options} />
                                    <br />
                                </TabPane>
                            </Tabs>
                        </Row>
                        <Row>
                            <div style={{ margin: '2em 6em' }}>
                                <h2>{strings.training.smartTipsTitle}</h2>
                                <div>
                                    {
                                        strings.training.smartTips.map(item => <h4 key={item.key} style={{ color: '#141' }}>{item.text}</h4>)
                                    }
                                </div>
                            </div>
                        </Row>
                    </Row>
                    <SaveEvent
                        key='save-event-modal'
                        msgs={strings}
                        isShown={showSaveModal}
                        onCancel={this.hideSaveModal}
                        onSave={this.saveEvent}
                        isLoading={savingInProgress}
                    />
                    {showChangeModal && <ChangeEvent
                        key='change-event-modal'
                        msgs={strings}
                        isShown={showChangeModal}
                        onCancel={this.hideChangeModal}
                        onSave={this.changeEvent}
                        isLoading={savingInProgress}
                        deviceToChange={deviceToChangeId}
                    />}
                    {showDeviceAssistant && <DeviceAssistant
                        key='change-event-modal'
                        msgs={strings}
                        isShown={showDeviceAssistant}
                        onCancel={this.hideDeviceAssistant}
                        onSave={this.saveDeviceAssistant}
                    />}
                </Layout.Content>
            </Layout>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        metersData: getMetersListSorted(state),
        userId: getUserId(state),
        preselectedMeterId: getPreselectedMeterId(state),
        isAdmin: isRoleAdministrator(state),
        data: getHistoricalListSeparated(state),
        assistant: getAssistantList(state),
        deviceList: getDeviceList(state),
        deviceTypesList: getDeviceTypesList(state),
        savingInProgress: getAddOrEditDeviceModalIsLoading(state),
        selectedItems: getSelectedList(state),
        zoomIsEnabled: isZoomEnabled(state),
        lang: selectedLangageSelector(state),
        periodFrom: getSmartTrainingPeriodFrom(state),
        periodTo: getSmartTrainingPeriodTo(state),
        minWh: getSmartTrainingMinWh(state),
        filteredDevice: getSmartTrainingFilteredDevice(state),
        groupBy: getPreselectedGroupById(state)
    }),
    {
        fetchHistoricalEvents,
        fetchAssistantEvents,
        fetchAllMeters,
        setLastPreselectedMeter,
        fetchAllDevices,
        fetchAllDeviceTypes,
        onAddOrEditDeviceModalIsLoading,
        onAddNewDevice,
        learnDevice,
        onToggleSelectItem,
        onClearSelection,
        onZoomSelection,
        onSetSmartTrainingPeriod,
        onSetSmartTrainingMinWh,
        onSetSmartTrainingDeviceFilter,
        setLastPreselectedGroupBy
    }
)(SmartTraining);
